import React, { useEffect, useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import { Accordion, Col, Container, Form, ListGroup, ListGroupItem, Row, Spinner } from "react-bootstrap";
import SplashPage from '../SplashPage';
import { BsFillBuildingsFill } from 'react-icons/bs';
import { useAuthState } from "../../context/AuthContext";
import defaultAvatar from '../../user.png';
import { useQuery, useQueryClient } from "react-query";
import { MdOutlineAvTimer } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import AreYouSureModal from "../../components/shared/AreYouSureModal";

/**
 * BUildingsPage
 * 
 * In this page will be shown all building logged user has in his management
 * 
 * @returns None
 */
const BuildingsPage = () => {

    const API = new PrivateApi(); // Class for API calls
    const { user, contactPerson } = useAuthState(); // logged user to compare with buildings
    const queryClient = useQueryClient();

    const [buildings, setBuildings] = useState([]); // Buildings array
    const [anlagen, setAnlagen] = useState([]); // Anlagen array
    const [tickets, setTickets] = useState([]); // Tickets array

    const [searchField, setSearchField] = useState(""); // Search field
    const [isSearchFieldFocus, setIsSearchFieldFocus] = useState(false);
    const [filteredBuildings, setFilteredBuildings] = useState([]); // Filtered buildings array, when search field is used
    const [onlyObjektbezichnung, setOnlyObjektbezeichnung] = useState(false) // filter only objektbezeichnung

    const [cancelModal, setCanceModal] = useState(false); // are you sure dialog modal
    const [cancelTicketId, setCancelTicketId] = useState(0); // ticket id for ticket which was abbrechen btn was clicked
    const [cancelLoading, setCancelLoading] = useState(false);

    const { data, error, isLoading } = useQuery("GET_BUILDINGS_QUERY", API.hw_Buildings, {
        staleTime: Infinity,
        onSuccess: (res) => {
            if (res.data.buildings.length > 0) {
                setBuildings(res.data.buildings.sort((a, b) => a.id - b.id));
                setFilteredBuildings(res.data.buildings);
            }
            if (res.data.tickets.length > 0) {
                setTickets(res.data.tickets);
            }
        }
    });



    const { data: anlagenData, error: anlagenError, isLoading: anlagenLoading } = useQuery("GET_ALL_ANLAGEN", API.get_Anlagen_all, { staleTime: Infinity }
    );


    // Effect when change is search field is detected (filter buildings)
    useEffect(() => {
        if (searchField.length !== 0) {
            var filtered = null;
            if (onlyObjektbezichnung) {
                filtered = buildings.filter(b => b.x_objektbezeichnung.toLowerCase().includes(searchField.toLowerCase()));
            } else {
                filtered = buildings.filter(b =>
                    b.name.toLowerCase().includes(searchField.toLowerCase()) ||
                    b.zip.toLowerCase().includes(searchField.toLowerCase()) ||
                    b.street.toLowerCase().includes(searchField.toLowerCase()) ||
                    b.city.toLowerCase().includes(searchField.toLowerCase()) ||
                    b.x_objektbezeichnung.toLowerCase().includes(searchField.toLowerCase())
                );
            }
            setFilteredBuildings(filtered);
        } else {
            setFilteredBuildings(buildings);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchField])


    // Function to load Anlagen from Odoo
    const getherAnlagen = (id) => {
        var tempList = anlagenData.filter(a => a.x_studio_field_Xhbek[0] === id || a.x_gebaeude_id[0] === id);
        setAnlagen(tempList);
    };

    // Deprecated for time beeing
    /* const goToAnlageDetails = (e, building_id, name) => {
        e.preventDefault();
        navigate(`/hw/dashboard/gebaeude/anlagen/${building_id}`, {state: {building: name}});
    } */

    const showCancelModal = (ticket_id) => {
        setCancelTicketId(ticket_id);
        setCanceModal(true);
    }

    
    // close ticket and new building
    const closeTicket = () => {
        var data = {ticket_id: cancelTicketId, user: contactPerson.name}
        setCancelLoading(true);
        API.post_Ticket_close(data)
            .then(() => {
                queryClient.invalidateQueries("GET_BUILDINGS_QUERY");
                var ticketElem = document.getElementById(`ticket-${cancelTicketId}`);
                if (ticketElem) {
                    ticketElem.style.display = 'none';
                }

                var elements = document.querySelectorAll('[id^="title-"]');
                if (elements.length === 0) {
                    var elementToHide = document.getElementById('newBuildingsPId');
                    if (elementToHide) {
                        elementToHide.style.display = 'none';
                    }
                }
                setCancelLoading(false);
                setCanceModal(false);
            });
    }


    // creates items for new building from ticket
    const createNewBuildingItems = (ticket) => {
        var building_info = {};
        var anlagen_info = [];

        if (ticket.description.includes('<tbody>')) {
            var tables = ticket.description.split('<tbody>');
            if (tables.length > 0) {
                var building_rows = tables[1].split('<tr>').filter(Boolean);

                building_rows.forEach(row => {
                    var matches = row.match(/<td>(.*?)<\/td>/g);
                    if (matches && matches.length >= 2) {
                        var key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                        var value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                        if (key === 'Gebäudename') building_info['name'] = value;
                        if (key === 'Objektbezeichnung') building_info['x_objektbezeichnung'] = value;
                        if (key === 'Vorgang') building_info['vorgang'] = value;
                        if (key === 'Straße') building_info['street'] = value;
                        if (key === 'Hausnummer') building_info['housenumber'] = value;
                        if (key === 'PLZ') building_info['zip'] = value;
                        if (key === 'Ort') building_info['city'] = value;
                        if (key === 'Kontaktperson') building_info['contact'] = value;
                    }
                });

                if (tables.length > 1) {
                    var new_anl = {};
                    for (let i = 1; i < tables.length; i++) {
                        var rows = tables[i].split('<tr>').filter(Boolean);
                        
                        rows.forEach(row => {
                            if (row.includes('end anlage')) {
                                anlagen_info.push(new_anl);
                                new_anl = {};
                            }
                            var matches = row.match(/<td>(.*?)<\/td>/g);
                            if (matches && matches.length >= 2) {
                                var key = matches[0].replace(/<td>|<\/td>/g, '').trim();
                                var value = matches[1].replace(/<td>|<\/td>/g, '').trim();

                                if (key === 'Anlagenverwendung') new_anl['x_anlagenverwendung'] = value;
                                if (key === 'Spezifische Anlagenverwendung') new_anl['x_anlagenverwendung_detail'] = value;
                                if (key === 'Top') new_anl['top'] = value;
                                if (key === 'Bestandeinheitennummer') new_anl['x_bestandheitsnummer'] = value;
                                if (key === 'Energieform') new_anl['x_energieform'] = value;
                                if (key === 'Zählernummer') new_anl['x_zaehlernummer_1'] = value;
                                if (key === 'Zweite Zählernummer') new_anl['x_zaehlernummer_2'] = value;
                                if (key === 'Anlage anmelden am') new_anl['register_from'] = value;
                                if (key === 'Als Leerstand anmelden') new_anl['leerstand'] = value;

                            }

                        });
                    }
                }

                return (
                    <Accordion.Item id={`ticket-${ticket.id}`} key={`ticket-${ticket.id}`} eventKey={`ticket-evt-${ticket.id}`} style={{marginBottom: "10px", border: "1px dashed #ced4da"}}>
                        <Accordion.Header style={{opacity: 0.5}}>
                            <Row style={{ width: "100%" }} className="align-items-center">
                                <Col xs="12" md="2" xl="1">
                                    <BsFillBuildingsFill size={70} />
                                </Col>
                                <Col xs="12" md="10" xl="11">
                                    {building_info.name} <br />
                                    <small>{building_info.street}, {building_info.zip} {building_info.city}</small> <br />
                                    {building_info.x_objektbezeichnung !== "False" ?
                                        <small><span className="text-muted">Objektbezeichnung: </span>{building_info.x_objektbezeichnung}</small>
                                        : null}
                                </Col>
                            </Row>
                        </Accordion.Header>
                        <Accordion.Body>
                            <Row style={{opacity: 0.5}}>
                                <Col xs="12" xl="4">
                                    <small className="text-muted">Straße</small>
                                    <p>{building_info.street}</p>
                                </Col>
                                <Col xs="12" xl="4">
                                    <small className="text-muted">PLZ</small>
                                    <p>{building_info.zip}</p>
                                </Col>
                                <Col xs="12" xl="4">
                                    <small className="text-muted">Ort</small>
                                    <p>{building_info.city}</p>
                                </Col>
                            </Row>
                            <hr />
                            <ListGroup variant="flush" className="text-start" style={{opacity: 0.5}}>
                                {anlagen_info.length > 0 ?
                                    anlagen_info.map(anlage =>
                                        <ListGroupItem>
                                            <Row className="text-center">
                                                <Col xs="12" md="4" xl="4" className="border-right">
                                                    <p className="text-muted"><small>Anlage anmelden</small></p>
                                                    {anlage.register_from !== undefined ?
                                                        <>
                                                            <FaCheck className="text-energo" /> &nbsp;
                                                            am {new Date(anlage.register_from).toLocaleDateString('DE-de')}
                                                        </>
                                                        :
                                                        <FaXmark className="text-danger" />
                                                    }
                                                </Col>
                                                <Col xs="12" md="4" xl="4" className="border-right">
                                                    <p className="text-muted"><small>Energieform</small></p>
                                                    <p>{anlage.x_energieform}</p>
                                                </Col>
                                                <Col xs="12" md="4" xl="4">
                                                    <p className="text-muted">Anlagenverwendung</p>
                                                    {
                                                        anlage.x_anlagenverwendung === 'Allgemeine Liegenschaftsteile'?
                                                            anlage.x_anlagenverwendung_detail :
                                                            `Top ${anlage.top}`
                                                    }
                                                </Col>
                                            </Row>
                                        </ListGroupItem>
                                    )

                                    : null
                                }
                            </ListGroup>
                            <hr />
                            <Row className="text-center accordion-footer">
                                <Col xs="12" md="4" xl="4">
                                    <a onClick={e => {e.preventDefault(); showCancelModal(ticket.id)}} href={`/gebaeude/abbrechen/${ticket.id}`} className="link-energo text-danger">Hinzufügen abbrechen</a>
                                </Col>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                )
            }
        }
    }


    // if loading
    if (isLoading || anlagenLoading) return <SplashPage />

    // if error 
    if (error || anlagenError) return <p>Es ist ein Fehler aufgetreten. Versuche es später erneut.</p>


    // GUI
    return (
        <Container className="text-start">
            <Row>
                <Col xs="12" xl={isSearchFieldFocus ? "4" : "8"}>
                    <h3>Alle verwalteten Gebäude</h3>
                </Col>
                <Col xs="12" xl={isSearchFieldFocus ? "8" : "4"}>
                    <Form.Control
                        onFocus={() => setIsSearchFieldFocus(true)}
                        onBlur={() => setIsSearchFieldFocus(false)}
                        className="rounded-pill"
                        value={searchField}
                        onChange={e => setSearchField(e.target.value)}
                        type="search"
                        placeholder="Suche nach Objektbezeichnung, Straße, Gebäudename, PLZ, Ort, ..."
                    />
                    <Form.Check
                        style={{ marginLeft: "5px", marginTop: "10px" }}
                        type="switch"
                        label="Nur Objektbezeichnung filtern"
                        onChange={e => setOnlyObjektbezeichnung(e.target.checked)}
                    />
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" xl="6">
                </Col>
            </Row>


            {tickets && tickets.length > 0 ?
                <Accordion className="mt-3">
                    <p id="newBuildingsPId">Neue Liegenschaft</p>
                    {tickets.map(ticket =>
                        createNewBuildingItems(ticket)
                    )}
                </Accordion>
                : null}


            <Accordion className="mt-5">
                {filteredBuildings.length > 0 ?
                    filteredBuildings.map((building) => (
                        <Accordion.Item key={building.id} eventKey={building.id} onClick={() => getherAnlagen(building.id)} style={{ marginBottom: "10px", border: "1px solid #ced4da" }}>
                            <Accordion.Header>
                                <Row style={{ width: "100%" }} className="align-items-center">
                                    <Col xs="12" md="2" xl="1">
                                        {/* if building is hv self show logo instead of building icon */}
                                        {building.id === user.id ?
                                            <div className="avatar-image" style={{ backgroundImage: `url(${user?.image_1920 && user.image_1920 !== "False" ? 'data:image/*;base64,' + user.image_1920 : defaultAvatar})`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}></div>
                                            :
                                            <BsFillBuildingsFill size={70} />
                                        }
                                    </Col>
                                    <Col xs="12" md="10" xl="11">
                                        {building.name} <br />
                                        <small>{building.street}, {building.zip} {building.city}</small> <br />
                                        {building.x_objektbezeichnung !== "False" ?
                                            <small><span className="text-muted">Objektbezeichnung: </span>{building.x_objektbezeichnung}</small>
                                            : null}
                                    </Col>
                                </Row>
                            </Accordion.Header>
                            <Accordion.Body>
                                <Row>
                                    <Col xs="12" xl="4">
                                        <small className="text-muted">Straße</small>
                                        <p>{building.street}</p>
                                    </Col>
                                    <Col xs="12" xl="4">
                                        <small className="text-muted">PLZ</small>
                                        <p>{building.zip}</p>
                                    </Col>
                                    <Col xs="12" xl="4">
                                        <small className="text-muted">Ort</small>
                                        <p>{building.city}</p>
                                    </Col>
                                </Row>
                                <hr />
                                <ListGroup variant="flush" className="text-start">
                                    {anlagen.length > 0 && anlagenLoading === false ?
                                        anlagen.map((anl) => (
                                            <ListGroup.Item key={anl.id}>
                                                <Row className="text-center">
                                                    <Col xs="12" md="4" xl="4" className="border-right">
                                                        <p className="text-muted"><small>Anlagennummer ENERGO</small></p>
                                                        {anl.x_studio_field_mWMGR}
                                                    </Col>
                                                    <Col xs="12" md="4" xl="4" className="border-right">
                                                        <p className="text-muted"><small>Energieform</small></p>
                                                        <p>{anl.x_studio_field_3eKe0}</p>
                                                    </Col>
                                                    <Col xs="12" md="4" xl="4">
                                                        <p className="text-muted"><small>Anlagenverwendung</small></p>
                                                        {anl.x_anlagenverwendung !== "False" ?
                                                            anl.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" ?
                                                                anl.x_anlagenverwendung_detail !== "False" ?
                                                                    anl.x_anlagenverwendung_detail
                                                                    :
                                                                    "Allgemeine Liegenschaftsteile"
                                                                :
                                                                anl.x_studio_field_6T9W2 !== "False" ? `Top ${anl.x_studio_field_6T9W2}` :
                                                                    anl.x_adresse_abw_top !== "False" ? `Top ${anl.x_adresse_abw_top}` :
                                                                        'Bestandseinheit'
                                                            :
                                                            "-"
                                                        }
                                                    </Col>
                                                </Row>
                                            </ListGroup.Item>
                                        ))
                                        : anlagenLoading ?
                                            <div className="text-center">
                                                <Spinner animation="grow" className="text-energo" /> &nbsp;
                                                <Spinner animation="grow" className="text-energo" /> &nbsp;
                                                <Spinner animation="grow" className="text-energo" />
                                            </div>
                                            : !anlagenLoading ?
                                                <div className="text-center">
                                                    Sie haben keine Anlagen in diesem Gebäude
                                                </div>
                                                : null
                                    }
                                </ListGroup>
                                <hr />
                                {anlagen.length > 0 && anlagenLoading === false ?
                                    <Row className="text-center accordion-footer">
                                        <Col xs="4" className="border-right">
                                            <a href={`/hw/dashboard/gebaeude/anlagen/${building.id}`} className="link-energo-light">Anlagenverwaltung</a>
                                        </Col>
                                        <Col xs="4" className="border-right">
                                            <a href={`/hw/dashboard/energieliefervertraege/gebaeude/${building.id}`} className="link-energo-light">Lieferverträge</a>
                                        </Col>
                                        <Col xs="4">
                                            <a href={`/hw/dashboard/gebaeude/dokumente/${building.id}`} className="link-energo-light">Dokumente</a>
                                        </Col>
                                    </Row>
                                    : null}
                            </Accordion.Body>
                        </Accordion.Item>
                    ))
                    : <p>Keine Gebäude gefunden...</p>
                }
            </Accordion>
            <AreYouSureModal 
                show={cancelModal} 
                setShow={setCanceModal} 
                title="Hinzufügen abbrechen" 
                message="Wollen Sie das Hinzufügen der Liegenschaft wirklich abbrechen?"
                yesHandler={closeTicket}
                loading={cancelLoading}
            />
        </Container>
    )
}

export default BuildingsPage;